<template>
<div class="chapter">
<div class="inner_page">
<div class="chaptitle"><span><a id="pagexii"></a><b>ILLUSTRATIONS</b></span></div>
<div class="ill2"><span>A Cavalryman from the Trans-Mississippi</span></div>
<div class="ill2"><span>Plates</span></div>
<div class="ill"><span>  <span href="#/plates#pla1" id="rpla1" title="Link target outside of Sample">1.  Ben McCulloch, Brigadier General</span></span></div>
<div class="ill1"><span><span href="#/plates#pla1-1" id="rpla1-1" title="Link target outside of Sample">Henry E. McCulloch, Brigadier General</span></span></div>
<div class="ill1"><span><span href="#/plates#pla1-2" id="rpla1-2" title="Link target outside of Sample">James McIntosh, Brigadier General</span></span></div>
<div class="ill1"><span><span href="#/plates#pla1-3" id="rpla1-3" title="Link target outside of Sample">Thomas J. Churchill, Major General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla2" id="rpla2" title="Link target outside of Sample">2.  Stand Watie, Brigadier General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla3" id="rpla3" title="Link target outside of Sample">3.  Henry Hopkins Sibley, Brigadier General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla4" id="rpla4" title="Link target outside of Sample">4.  Earl Van Dorn, Major General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla5" id="rpla5" title="Link target outside of Sample">5.  Theophilus H. Holmes, Lieutenant General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla6" id="rpla6" title="Link target outside of Sample">6.  Thomas C. Hindman, Major General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla7" id="rpla7" title="Link target outside of Sample">7.  John A. Wharton, Major General</span></span></div>
<div class="ill1"><span><span href="#/plates#pla7-1" id="rpla7-1" title="Link target outside of Sample">Xavier Blanchard De Bray, Brigadier General (not approved by President Davis)</span></span></div>
<div class="ill1"><span><span href="#/plates#pla7-2" id="rpla7-2" title="Link target outside of Sample">James F. Fagan, Major General</span></span></div>
<div class="ill1"><span><span href="#/plates#pla7-3" id="rpla7-3" title="Link target outside of Sample">William P. Steele, Brigadier General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla8" id="rpla8" title="Link target outside of Sample">8.  John Sappington Marmaduke, Major General</span></span></div>
<div class="ill"><span>  <span href="#/plates#pla9" id="rpla9" title="Link target outside of Sample">9.  Joseph Orville Shelby, Brigadier General</span></span></div>
<div class="ill"><span><span href="#/plates#pla10" id="rpla10" title="Link target outside of Sample">10.  Sterling Price, Major General</span></span></div>
<div class="ill"><span><span href="#/plates#pla11" id="rpla11" title="Link target outside of Sample">11.  John S. Ford, Colonel</span></span></div>
<div class="ill"><span><span href="#/plates#pla12" id="rpla12" title="Link target outside of Sample">12.  Edmund Kirby Smith, Lieutenant General</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustration.vue?5734c04f